import useAuthToken from '../storage/token/hook';
export default function useIsLoggedIn() {
    const [token] = useAuthToken();
    return !!token;
}
